var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRest2FaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1235 5C9.86748 5 8.7295 6.948 7 7.5C6.2965 7.725 5.62023 7.403 5.47773 7.56125C5.33523 7.71875 5.29398 7.9505 5.21073 8.4125C4.31823 13.3595 6.26823 17.933 10.9182 19.7135C11.417 19.9048 11.6667 20 12.1257 20C12.5847 20 12.8352 19.904 13.3347 19.7128C17.984 17.933 19.9317 13.3595 19.0392 8.4125C18.956 7.9505 18.914 7.71875 18.7715 7.5605C18.629 7.40225 17.7035 7.72425 17 7.5C15.2698 6.948 14.3795 5 12.1235 5Z",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 13.25C9.875 13.25 10.625 13.25 11.375 14.75C11.375 14.75 13.7578 11 15.875 10.25",
    stroke: "#475569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRest2FaIcon);
export default __webpack_public_path__ + "static/media/Rest2FAIcon.801124a4c7bf0520d10b97c67e9b3c05.svg";
export { ForwardRef as ReactComponent };